export const PROMOCODES_PAGE_URL = '/cabinet/promocodes';
